import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid io-media-row__image"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "io-card__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyBackgroundMedia = _resolveComponent("LazyBackgroundMedia")!
  const _component_Observer = _resolveComponent("Observer")!

  return (_openBlock(), _createBlock(_component_Observer, {
    class: _normalizeClass(["io-media-row", _ctx.classes]),
    threshold: 0.38197,
    onObserveenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.observed = true))
  }, {
    default: _withCtx(() => [
      (_ctx.hasMedia)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createVNode(_component_LazyBackgroundMedia, {
                "media-sizes": _ctx.mediaSizes,
                "background-position-y": _ctx.backgroundPositionY,
                "background-position-x": _ctx.backgroundPositionX,
                "media-mobile-sizes": _ctx.mediaMobileSizes,
                "background-position-mobile-y": _ctx.backgroundPositionMobileY,
                "background-position-mobile-x": _ctx.backgroundPositionMobileX,
                class: "io-media-row__image-media"
              }, null, 8, ["media-sizes", "background-position-y", "background-position-x", "media-mobile-sizes", "background-position-mobile-y", "background-position-mobile-x"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "io-media-row__card",
          onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hovering = true)),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hovering = false))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 32)
      ])
    ]),
    _: 3
  }, 8, ["class", "threshold"]))
}